"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageFooter_1 = require("./PageFooter");
exports.default = PageFooter_1.default;
//# sourceMappingURL=index.js.map